import { render } from "./TreeFoldermove.vue?vue&type=template&id=3896911c&scoped=true"
import script from "./TreeFoldermove.js?vue&type=script&lang=js"
export * from "./TreeFoldermove.js?vue&type=script&lang=js"

import "./TreeFoldermove.vue?vue&type=style&index=0&id=3896911c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3896911c"]])

export default __exports__